import appTranslationsHelper from "./app-translations.helper";
import OrderOptimizerCargoDetailsTranslations from "./types/order-optimizer/cargo/order-optimizer-cargo-details.translations";
import OrderOptimizerCargoListingTranslations from "./types/order-optimizer/cargo/order-optimizer-cargo-listing.translations";
import OrderOptimizerRailyDetailsTranslations from "./types/order-optimizer/raily/order-optimizer-raily-details.translations";
import OrderOptimizerRailyListingTranslations from "./types/order-optimizer/raily/order-optimizer-raily-listing.translations";
import OrderOptimizerTaxiDetailsTranslations from "./types/order-optimizer/taxi/order-optimizer-taxi-details.translations";
import OrderOptimizerTaxiListingTranslations from "./types/order-optimizer/taxi/order-optimizer-taxi-listing.translations";

const getTranslations = <T>(internalFilePath: string): T => {
  const baseFilePath = `order-optimizer`;

  const filePath = `${baseFilePath}/${internalFilePath}`;

  return appTranslationsHelper.getTranslations(filePath);
};

const getRailyListingTranslations =
  (): OrderOptimizerRailyListingTranslations => {
    const translations =
      getTranslations<OrderOptimizerRailyListingTranslations>(
        "raily/order-optimizer-raily-listing.translations.json"
      );

    return translations;
  };

const getRailyDetailsTranslations =
  (): OrderOptimizerRailyDetailsTranslations => {
    const translations =
      getTranslations<OrderOptimizerRailyDetailsTranslations>(
        "raily/order-optimizer-raily-details.translations.json"
      );

    return translations;
  };

const getTaxiListingTranslations =
  (): OrderOptimizerTaxiListingTranslations => {
    const translations = getTranslations<OrderOptimizerTaxiListingTranslations>(
      "taxi/order-optimizer-taxi-listing.translations.json"
    );

    return translations;
  };

const getTaxiDetailsTranslations =
  (): OrderOptimizerTaxiDetailsTranslations => {
    const translations = getTranslations<OrderOptimizerTaxiDetailsTranslations>(
      "taxi/order-optimizer-taxi-details.translations.json"
    );

    return translations;
  };

const getCargoListingTranslations =
  (): OrderOptimizerCargoListingTranslations => {
    const translations =
      getTranslations<OrderOptimizerCargoListingTranslations>(
        "cargo/order-optimizer-cargo-listing.translations.json"
      );

    return translations;
  };

const getCargoDetailsTranslations =
  (): OrderOptimizerCargoDetailsTranslations => {
    const translations =
      getTranslations<OrderOptimizerCargoDetailsTranslations>(
        "cargo/order-optimizer-cargo-details.translations.json"
      );

    return translations;
  };

const orderOptimizerTranslationsHelper = {
  getCargoListingTranslations,
  getCargoDetailsTranslations,
  getRailyListingTranslations,
  getRailyDetailsTranslations,
  getTaxiListingTranslations,
  getTaxiDetailsTranslations,
};

export default orderOptimizerTranslationsHelper;
